import {useContext} from 'external/react'
import { clientService } from 'services/client.service'
import { userService } from 'services/user.service'

import Parent from 'context/parent-context'
import useAuth from 'context/auth-context/hook'

export default function useParent() {

    const {user} = useAuth()

	const {state, update} = useContext(Parent.Context)
    const {homeData, supportForm, props: {navigation, params, query}} = state
    
    async function deleteUser (userId: string) {
        const userIndex = state.users.items.findIndex(({id}) => userId === id) 
        if (userIndex < 0) return 'Usuario no encontrado'
        const {data: deletionResponse} = await userService.delete(userId, user.id)
        if (deletionResponse.user_assigned) {
           return deletionResponse.statusResponse.message 
        }
        update({users: {items: {$splice: [[userIndex, 1]]}}})
        return true
    }

    async function addUser(newUser:any) {
       await userService.create({...newUser, client_id: user.id, role: params.role}) 
       update({users: {refreshes: {$apply: i => i + 1}}})
    }

    async function editUser(changedUser:any) {
        changedUser.name = `${changedUser.first_name} ${changedUser.last_name}`
		update({users: {items: {[changedUser.index]: {$set: changedUser}}}})
		const editResponse = await userService.update({...changedUser, profile_id: changedUser.id, client_id: user.id, credentials: {password: changedUser.password}})
        return editResponse
    }

    async function updateProfile(updatedProfile:any) {
		const updateResponse = await clientService.updateProfile(updatedProfile)
        return updateResponse
    }

    async function updatePassword(updatedPasswords: any) {
		const updateResponse = await clientService.updatePassword({id: user.id, oldPassword: updatedPasswords.oldPassword, password: updatedPasswords.password})
        return updateResponse
    }

    return {
        homeData,
        updateProfile,
        updatePassword,
        addUser,
        editUser,
        deleteUser,
        supportForm,
        state,
        params,
        query,
        navigation,
        update
    }

}